import { useState } from "react"
import { HorizontalGroup, P } from "../../components"
import { HoverContainer } from "./featureList_style"

interface FeatureListProps {
	data: {
		title: string
		hoverInfo: string
	}[]
	textColor?: string
}

const FeatureList = ({ data, textColor }: FeatureListProps) => {
	const [infoHovered, setInfoHovered] = useState(-1)

	return (
		<>
			{data.map((item, index) => (
				<HorizontalGroup
					alignItems="center"
					justifyContent="space-between"
					style={{ marginBottom: "14px", position: "relative" }}
					key={item.title}
				>
					<HorizontalGroup alignItems="center">
						<svg
							width="12"
							height="10"
							viewBox="0 0 12 10"
							fill="none"
							xmlns="http://www.w3.org/2000/svg"
						>
							<path
								fillRule="evenodd"
								clipRule="evenodd"
								d="M11.706 1.79146L5.37196 9.709L0.397217 5.56338L1.33615 4.43666L5.16141 7.62437L10.5607 0.875244L11.706 1.79146Z"
								fill={textColor ?? "#333333"}
							/>
						</svg>
						<P color={textColor} style={{ marginLeft: "8px" }}>
							{item.title}
						</P>
					</HorizontalGroup>
					<svg
						width="17"
						height="16"
						viewBox="0 -1 15 18"
						fill="none"
						xmlns="http://www.w3.org/2000/svg"
						onMouseEnter={() => setInfoHovered(index)}
						onMouseLeave={() => setInfoHovered(-1)}
					>
						<g opacity="0.4">
							<path
								fillRule="evenodd"
								clipRule="evenodd"
								d="M8 4.48999V5.49999H7V4.48999H8ZM6 11.5V10.5H7L7 8.49999H6V7.49999L8 7.49999L8 10.5H9V11.5H6Z"
								fill={textColor ?? "#333333"}
							/>
							<path
								d="M7.5 14.5C3.91015 14.5 1 11.5899 1 8H-1C-1 12.6944 2.80558 16.5 7.5 16.5V14.5ZM14 8C14 11.5899 11.0899 14.5 7.5 14.5V16.5C12.1944 16.5 16 12.6944 16 8H14ZM7.5 1.5C11.0899 1.5 14 4.41015 14 8H16C16 3.30558 12.1944 -0.5 7.5 -0.5V1.5ZM7.5 -0.5C2.80558 -0.5 -1 3.30558 -1 8H1C1 4.41015 3.91015 1.5 7.5 1.5V-0.5Z"
								fill={textColor ?? "#333333"}
							/>
						</g>
					</svg>

					<HoverContainer
						style={{
							opacity: infoHovered === index ? 1 : 0,
						}}
					>
						<P style={{ lineHeight: "20px" }}>{item.hoverInfo}</P>
					</HoverContainer>
				</HorizontalGroup>
			))}
		</>
	)
}

export default FeatureList
